import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PublicRoute = ({ children, redirectTo = null }) => {
 const { isAuthenticated, user, isLoading } = useAuth();
 const location = useLocation();

 // Show loading spinner while checking authentication
 if (isLoading) {
 return (
 <div className="min-h-screen flex items-center justify-center">
 <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-ink"></div>
 </div>
 );
 }

 // If user is authenticated, redirect them away from public pages
 if (isAuthenticated && user) {
 // Use custom redirect path if provided, otherwise redirect to appropriate dashboard
 const redirectPath = redirectTo || (
 user.user_type === 'admin' ? '/admin' : 
 user.user_type === 'vendor' ? '/vendor' : '/dashboard'
 );
 
 // Get the intended destination from state, or use the default redirect
 const from = location.state?.from?.pathname || redirectPath;
 
 return <Navigate to={from} replace />;
 }

 return children;
};

export default PublicRoute;
